import Square from "./Square";

class Node {

    constructor(x,y) {
        this.x = x;
        this.y = y;
    }

    isSameNode(node) {
        return node.x === this.x && node.y === this.y;
    }
       
    calcularHeuristica(fn) {
        //this.h = Math.sqrt( (fn.x - this.x)**2 + (fn.y - this.y)**2);
        this.h = Math.abs(fn.x - this.x) + Math.abs(fn.y - this.y);
    }

    getF() {
        return this.h + this.g;
    }

    getNeighbours(grid) {
        let neighbours = [];
        //debugger;
        if (this.x < grid.length - 1 && !grid[this.x + 1][this.y].props.hasOwnProperty("wall")) {
            neighbours.push(new Node(this.x+1, this.y));
        }
        if (this.x > 0 && !grid[this.x - 1][this.y].props.hasOwnProperty("wall")) {
            neighbours.push(new Node(this.x-1, this.y));
        }

        if (this.y < grid.length - 1 && !grid[this.x][this.y + 1].props.hasOwnProperty("wall")) {
            neighbours.push(new Node(this.x, this.y+1));
        }

        if (this.y > 0 && !grid[this.x][this.y - 1].props.hasOwnProperty("wall")) {
            neighbours.push(new Node(this.x, this.y-1));
        }        
        return neighbours;
    }

}

export default Node;